import { render, staticRenderFns } from "./sustainabilityButton.vue?vue&type=template&id=66dfdf5e&scoped=true"
import script from "./sustainabilityButton.vue?vue&type=script&lang=js"
export * from "./sustainabilityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfdf5e",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard});qInstall(component, 'directives', {Ripple});
